import {
  getEventAggregationColumn,
  getEventAggregationType,
  getEventFilter,
  getEventName,
  getEventsGroupColumn,
  getEventSplitColumn,
  getFieldPathKeys,
  getFieldPathsFor,
  getGlobalFilter,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import { toFilter, toOthersFilter } from '../../converters/filterConverter';

export const getAggregationType = (agr) => {
  switch (agr) {
    case 'sum':
      return 'TOTAL';
    case 'count':
      return 'COUNT';
    case 'uniq':
      return 'USERS';
    case 'avg_count':
      return 'AVERAGE_COUNT';
    case 'avg_total':
      return 'AVERAGE_TOTAL';
    case 'avg_count_split':
      return 'AVERAGE_COUNT_SPLIT';
    case 'avg_total_split':
      return 'AVERAGE_TOTAL_SPLIT';
    default:
      return 'COUNT';
  }
};

export const createDashboardQuery = (state, unit, event /* , period = {} */) => {
  const { name, aggregationType, aggregationColumn } = event;
  const groupBy = unit.compose.events.groupColumn;
  const split = event.splitColumn;

  const groups = split ? [groupBy, split] : [groupBy];

  return {
    eventName: name,
    aggregations: [
      {
        type: getAggregationType(aggregationType),
        field: aggregationColumn,
      },
    ],
    groupBy: groups,
    filter: toFilter(event.filter),
    globalFilter: {
      ...toFilter(getGlobalFilter(state)),
      // ...period
    },
    timezone: getProjectZoneId(state),
  };
};

export const createDashboardOthersQuery = (state, unit, event, clauseId) => {
  const { name, aggregationType, aggregationColumn } = event;
  const groupBy = unit.compose.events.groupColumn;
  const eventFilter = event.filter;
  const globalFilter = getGlobalFilter(state);

  return {
    eventName: name,
    aggregations: [
      {
        type: getAggregationType(aggregationType),
        field: aggregationColumn,
      },
    ],
    groupBy: [groupBy],
    filter: toOthersFilter(eventFilter, clauseId),
    globalFilter: {
      ...toFilter(globalFilter),
    },
    timezone: getProjectZoneId(state),
  };
};

export const createQuery = (state, id, period = {}) => {
  const name = getEventName(state, id);
  const aggregationType = getEventAggregationType(state, id);
  const aggregationColumn = getEventAggregationColumn(state, id);
  const groupBy = getEventsGroupColumn(state);
  const split = getEventSplitColumn(state, id);

  const groups = split ? [groupBy, split] : [groupBy];

  return {
    eventName: name,
    aggregations: [
      {
        type: getAggregationType(aggregationType),
        field: aggregationColumn,
      },
    ],
    groupBy: groups,
    filter: toFilter(getEventFilter(state, id)),
    globalFilter: {
      ...toFilter(getGlobalFilter(state)),
      ...period,
    },
    timezone: getProjectZoneId(state),
  };
};

export const createOthersQuery = (state, id, clauseId) => {
  const name = getEventName(state, id);
  const aggregationType = getEventAggregationType(state, id);
  const aggregationColumn = getEventAggregationColumn(state, id);
  const groupBy = getEventsGroupColumn(state);
  const eventFilter = getEventFilter(state, id);
  const globalFilter = getGlobalFilter(state);

  return {
    eventName: name,
    aggregations: [
      {
        type: getAggregationType(aggregationType),
        field: aggregationColumn,
      },
    ],
    groupBy: [groupBy],
    filter: toOthersFilter(eventFilter, clauseId),
    globalFilter: {
      ...toFilter(globalFilter),
    },
    timezone: getProjectZoneId(state),
  };
};

export const getTypeField = (field, state) =>
  getFieldPathKeys(state)
    .flatMap((pathKey) => getFieldPathsFor(state, pathKey))
    .find((s) => s.path === field) || {};
